import { GridFilterModel, GridSortModel } from '@mui/x-data-grid-pro';
import { IPagination } from './interfaces/pagination.interface';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';

export enum TableActions {
  SET_SORT = 'SET_SORT',
  SET_FILTER = 'SET_FILTER',
  SET_PAGINATION = 'SET_PAGINATION',
}

export interface TableAction {
  type: TableActions;
  payload: GridSortModel | GridFilterModel | Partial<IPagination>;
}

export interface TableState {
  sort: GridSortModel;
  filter: GridFilterModel | undefined;
  pagination: IPagination;
}

const defaultPagination = {
  page: 0,
  pageSize: 10,
};

export const defaultTableState = (
  initialState?: GridInitialStatePro | undefined
): TableState => {
  return {
    sort: initialState?.sorting?.sortModel || [],
    filter: initialState?.filter?.filterModel || undefined,
    pagination: initialState?.pagination || defaultPagination,
  };
};

export function tableReducer(state: TableState, action: TableAction) {
  const { type, payload } = action;
  switch (type) {
    case TableActions.SET_SORT:
      return {
        ...state,
        sort: payload,
      };
    case TableActions.SET_FILTER:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: 0,
        },
        filter: payload,
      };
    case TableActions.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...payload,
        },
      };
    default:
      return state;
  }
}
